import React from 'react';
import './banner.css';

function Banner({ onNavigate }) {
  return (
    <section className='banner' id='top'>
      <div className='herosection'>
        <div className='headline'>
          <span className='eyebrow'>Future-ready business support</span>
          <h1>
            Creating and transforming businesses<br />
            with <span>technology</span>
          </h1>
          <p>
            We deliver cutting-edge IT, industrial support, and digital commerce
            solutions for ambitious businesses ready to scale.
          </p>

          <div className='ctaRow'>
            <button type='button' className='primaryCta' onClick={() => onNavigate('about')}>Learn More</button>
            <button type='button' className='secondaryCta' onClick={() => onNavigate('products')}>Our Products</button>
          </div>

          <div className='statsGrid'>
            <div>
              <strong>10+</strong>
              <span>Years</span>
            </div>
            <div>
              <strong>25+</strong>
              <span>Projects</span>
            </div>
            <div>
              <strong>24/7</strong>
              <span>Support</span>
            </div>
          </div>
        </div>

        <div className='heroVisual'>
          <img className='heroimage' src={'/hero-imagery.png'} alt='Business innovation illustration' />
          <div className='floatingCard'>
            <span>Digital Growth</span>
            <strong>+40% Operations Efficiency</strong>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;